import { render } from "./ListMatching.vue?vue&type=template&id=19a35931&scoped=true"
import script from "./ListMatching.vue?vue&type=script&lang=js"
export * from "./ListMatching.vue?vue&type=script&lang=js"

import "./ListMatching.vue?vue&type=style&index=0&id=19a35931&scoped=true&lang=css"
import "./ListMatching.vue?vue&type=style&index=1&id=19a35931&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a35931"]])

export default __exports__